import TextField from './LqVTextField'
export default TextField.extend({
    name: 'lq-v-textarea',
    data () {
        return {
            tagName: 'v-textarea'
        }
    }
})